<template>
  <el-table-column
    prop="supplier.name"
    label="Szállító"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.supplier.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
